import React, { FunctionComponent } from 'react';

import { MEDIUM_GREY } from 'constants/colours';

type ChevronDirection = 'up' | 'right' | 'down' | 'left';

/**
 * Chevron Icon
 */
const ChevronIcon: FunctionComponent<
  React.PropsWithChildren<{
    className?: string;
    direction: ChevronDirection;
    color?: string;
    strokeWidth?: number;
  }>
> = ({ className, direction, color = MEDIUM_GREY, strokeWidth = 1.5 }) => {
  if (direction === 'up' || direction === 'down') {
    return (
      <svg
        className={`${className} ${direction === 'down' ? '' : 'tw-rotate-180'}`}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={'M7.41 8.29492L12 12.8749L16.59 8.29492L18 9.70492L12 15.7049L6 9.70492L7.41 8.29492Z'}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          direction === 'left'
            ? 'M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z'
            : 'M9.70492 6L8.29492 7.41L12.8749 12L8.29492 16.59L9.70492 18L15.7049 12L9.70492 6Z'
        }
        stroke={color}
        strokeWidth={strokeWidth}
        fill="black"
      />
    </svg>
  );
};

export default ChevronIcon;
